import { Field, Label, ErrorMessage } from "V2.0/common/fieldset";
import { Input } from "V2.0/common/input";

export default KeyValuePairForm;

function KeyValuePairForm(props) {
  const { formState, updateFormState, errors } = props;

  return (
    <div className="flex flex-col gap-y-8">
      <Field>
        <Label>Key *</Label>
        <Input
          type="text"
          value={formState.key}
          onChange={(e) => updateFormState("key", e.target.value)}
          invalid={!!errors.key}
        />
        {errors.key && <ErrorMessage>{errors.key}</ErrorMessage>}
      </Field>
      <Field>
        <Label>Value *</Label>
        <Input
          type="text"
          value={formState.value}
          onChange={(e) => updateFormState("value", e.target.value)}
          invalid={!!errors.value}
        />
        {errors.value && <ErrorMessage>{errors.value}</ErrorMessage>}
      </Field>
    </div>
  );
}
